(() => {
  const updateFileLabel = (input) => {
    const form = input.form;
    if (!form) return;
    const nameField = form.querySelector('[data-adelaide-contact-filename]');
    const label = form.querySelector('[data-adelaide-contact-file-label]');
    const fileName = input.files && input.files[0] ? input.files[0].name : '';
    if (nameField) nameField.value = fileName;
    if (label) {
      label.textContent = fileName || label.dataset.defaultLabel || 'Add File';
    }
  };

  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-adelaide-contact-file]');
    if (input) updateFileLabel(input);
  });
})();
